module.exports = "../fonts/check_box_gray.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check_box_gray.svg
// module id = 357
// module chunks = 0